import { useRaceSeries } from '@/hooks/useRaceSeries';
import { useRaceSeriesActions } from './useRaceSeriesActions';
import RaceSeriesManagerView from './raceseriesmanager.view';

const RaceSeriesManager = () => {
  const { data: seriesList = [], isLoading: loading } = useRaceSeries();
  const actions = useRaceSeriesActions();

  return (
    <RaceSeriesManagerView
      seriesList={seriesList}
      loading={loading}
      isDialogOpen={actions.isDialogOpen}
      setIsDialogOpen={actions.setIsDialogOpen}
      editingSeries={actions.editingSeries}
      formData={actions.formData}
      setFormData={actions.setFormData}
      openCreate={actions.openCreate}
      openEdit={actions.openEdit}
      handleSubmit={actions.handleSubmit}
      handleDelete={actions.handleDelete}
      deleteTarget={actions.deleteTarget}
      setDeleteTarget={actions.setDeleteTarget}
      confirmDelete={actions.confirmDelete}
    />
  );
};

export default RaceSeriesManager;
